import { useNavigate } from "react-router-dom";
import { toast } from "sonner";

import { useApi } from "../context/ApiContext";
import { useConfirm } from "../context/ConfirmContext.jsx";

export const useTaskActions = () => {
  const api = useApi();
  const navigate = useNavigate();

  const notifyUpdate = () => {
    window.dispatchEvent(new CustomEvent("taskUpdated"));
  };

  const updateTaskStatus = async (taskId, status) => {
    try {
      await api.put(`/tasks/${taskId}/status`, { status });
      toast.success("Task status updated!");
      notifyUpdate();
    } catch (error) {
      toast.error(error.message || "Failed to update task status");
    }
  };

  const reassignTask = async (taskId, assignedTo) => {
    try {
      await api.put(`/tasks/${taskId}/assign`, { assignedTo: assignedTo });
      toast.success("Task reassigned successfully!");
      notifyUpdate();
    } catch (error) {
      toast.error(error.message || "Failed to reassign task");
    }
  };

  const confirm = useConfirm();

  const deleteTask = async (taskId) => {
    const isConfirmed = await confirm({
      title: "Delete Task",
      message: "Are you sure you want to delete this task?"
    });
    if (isConfirmed) {
      try {
        await api.delete(`/tasks/${taskId}`);
        toast.success("Task deleted successfully!");
        notifyUpdate();
      } catch (error) {
        toast.error(error.message || "Failed to delete task");
      }
    }
  };

  const { pathname } = window.location;

  const editTask = (taskId) => {
    if (pathname.includes("/tasks")) {
      window.dispatchEvent(new CustomEvent("editTaskRequested", { detail: taskId }));
    } else {
      navigate(`/tasks?editTaskId=${taskId}`);
    }
  };

  return {
    updateTaskStatus,
    reassignTask,
    deleteTask,
    editTask
  };
};
